let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22HLg")).then(() => parcelRequire('5dZBJ'));